// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.sticky-header-animation-init {
  transform: translateY(-100%);
}

.sticky-header-animation-init.sticky-head {
  transition: transform 0.2s ease-in-out;
  transform: translateY(0);
}

.main-content-trans {
  background: transparent !important;
  background-image: none !important;
}

.user-menu {
  height: 100%;
  color: #000;
  text-decoration: none !important;
  padding: 0 1rem;
  z-index: 10;
  cursor: pointer;
}

.user-menu:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-menu-item {
  height: 100%;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user-image-wrapper {
  height: 70px;
  background-color: transparent;
  z-index: 20;
}

.circle-frame {
  background-position: 50% 35% !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-color: #d4d4d4 !important;
  border: 1px solid #ececec;
  border-radius: 19%;
  min-width: 10%;
  height: auto;
  padding-top: 10%;
  float: left;
}

.user-image {
  text-align: center;
  display: inline-block;
  margin-top: 14px;
  height: 40px;
  width: 40px;
  border-radius: 10%;
  overflow: hidden;
}

.user-image img {
  width: 100%;
}

.user-name-wrapper {
  color: #000;
  font-weight: bold;
  padding-left: 1rem;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.user-menu:hover .user-name-wrapper {
  color: #3b82f6; /* blue-500 */
  text-decoration: none;
  padding-left: 1rem;
}

.user-name-wrapper i {
  padding: 0 0.3rem;
}

.user-menu.show {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-menu.show .user-dropdown {
  box-shadow: -2px 4px 7px #ccc;
  display: block;
}

.user-dropdown {
  position: absolute;
  top: 70px;
  display: none;
  right: 1.5em;
  width: max-content;
  background-color: #fff;
  cursor: pointer;
}

.dropdown-item {
  color: black;
  display: block;
  padding: 1rem;
  text-decoration: none;
}

.dropdown-item.active {
  color: white;
  display: block;
  padding: 1rem;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #eff6ff; /* blue-50 */
  color: #3b82f6; /* blue-500 */
}

.dropdown-item.active:hover {
  background-color: #2563eb; /* blue-600 */
  color: white;
}

.dropdown-item span {
  color: #3b82f6; /* blue-500 */
  display: inline-block;
  width: 1.5rem; /* w-6 */
  text-align: center;
}

.dropdown-item.active span {
  color: white;
  display: inline-block;
  width: 1.5rem; /* w-6 */
  text-align: center;
}

.logo-web {
  display: flex;
  height: 51px;
  transition: all 0.2s ease-in-out !important;
}
.logo-mobile {
  display: none;
  height: 51px;
}

.stuck .logo-web {
  height: 45px;
}

@media (max-width: 991.98px) {
  .logo-web {
    display: none;
  }
  .logo-mobile {
    display: flex;
  }
}

.profile-picture {
  border-radius: 0.42rem;
  overflow: hidden;
  box-sizing: content-box;
}
.small-profile-picture {
  border: #ffffffa3 solid 3px;
  width: 50px;
  height: 50px;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/top-menu/top-menu.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,qBAAqB;EACrB,aAAa,EAAE,QAAQ;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa,EAAE,QAAQ;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA,4yMAA4yM","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.sticky-header-animation-init {\n  transform: translateY(-100%);\n}\n\n.sticky-header-animation-init.sticky-head {\n  transition: transform 0.2s ease-in-out;\n  transform: translateY(0);\n}\n\n.main-content-trans {\n  background: transparent !important;\n  background-image: none !important;\n}\n\n.user-menu {\n  height: 100%;\n  color: #000;\n  text-decoration: none !important;\n  padding: 0 1rem;\n  z-index: 10;\n  cursor: pointer;\n}\n\n.user-menu:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-menu-item {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.user-image-wrapper {\n  height: 70px;\n  background-color: transparent;\n  z-index: 20;\n}\n\n.circle-frame {\n  background-position: 50% 35% !important;\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n  background-color: #d4d4d4 !important;\n  border: 1px solid #ececec;\n  border-radius: 19%;\n  min-width: 10%;\n  height: auto;\n  padding-top: 10%;\n  float: left;\n}\n\n.user-image {\n  text-align: center;\n  display: inline-block;\n  margin-top: 14px;\n  height: 40px;\n  width: 40px;\n  border-radius: 10%;\n  overflow: hidden;\n}\n\n.user-image img {\n  width: 100%;\n}\n\n.user-name-wrapper {\n  color: #000;\n  font-weight: bold;\n  padding-left: 1rem;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.user-menu:hover .user-name-wrapper {\n  color: #3b82f6; /* blue-500 */\n  text-decoration: none;\n  padding-left: 1rem;\n}\n\n.user-name-wrapper i {\n  padding: 0 0.3rem;\n}\n\n.user-menu.show {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-menu.show .user-dropdown {\n  box-shadow: -2px 4px 7px #ccc;\n  display: block;\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 70px;\n  display: none;\n  right: 1.5em;\n  width: max-content;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.dropdown-item {\n  color: black;\n  display: block;\n  padding: 1rem;\n  text-decoration: none;\n}\n\n.dropdown-item.active {\n  color: white;\n  display: block;\n  padding: 1rem;\n  text-decoration: none;\n}\n\n.dropdown-item:hover {\n  background-color: #eff6ff; /* blue-50 */\n  color: #3b82f6; /* blue-500 */\n}\n\n.dropdown-item.active:hover {\n  background-color: #2563eb; /* blue-600 */\n  color: white;\n}\n\n.dropdown-item span {\n  color: #3b82f6; /* blue-500 */\n  display: inline-block;\n  width: 1.5rem; /* w-6 */\n  text-align: center;\n}\n\n.dropdown-item.active span {\n  color: white;\n  display: inline-block;\n  width: 1.5rem; /* w-6 */\n  text-align: center;\n}\n\n.logo-web {\n  display: flex;\n  height: 51px;\n  transition: all 0.2s ease-in-out !important;\n}\n.logo-mobile {\n  display: none;\n  height: 51px;\n}\n\n.stuck .logo-web {\n  height: 45px;\n}\n\n@media (max-width: 991.98px) {\n  .logo-web {\n    display: none;\n  }\n  .logo-mobile {\n    display: flex;\n  }\n}\n\n.profile-picture {\n  border-radius: 0.42rem;\n  overflow: hidden;\n  box-sizing: content-box;\n}\n.small-profile-picture {\n  border: #ffffffa3 solid 3px;\n  width: 50px;\n  height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
